<!-- 产品检测 -->
<template>
  <div class="productTesting">
    <!-- 背景图 -->
    <TopImg
      :title="topImg.title"
      :content="topImg.content"
      :aLink="topImg.aLink"
      :blName="topImg.blName"
      :image="topImg.bgImg"
      :bl="topImg.bl"
    ></TopImg>
    <!-- 检测服务范围 -->
    <TestServe :testServe="testServe"></TestServe>
    <!-- 服务场景 -->
    <AdressServe :adressServe="adressServe"></AdressServe>
    <!-- 关键指标 -->
    <TitleImg :title="titleImg.title" :image="titleImg.img"></TitleImg>
    <!-- 业务流程 -->
    <Process :title="titleImg.title" :image="titleImg.img"></Process>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import TestServe from '../components/TestServe'
import AdressServe from '../components/AdressServe'
import TitleImg from '../components/TitleImg'
import Process from '../components/Process'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, TestServe, AdressServe, TitleImg, Process, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '',
        bgImg: require('../assets/images/u1172.png'),
        content: '',
        bl: true,
        aLink: 'issueTest',
        blName: '立即咨询',
      },
      testServe: [
        {
          title: '服务范围',
          child: [
            {
              id: 1,
              title: '面料检测',
              content:
                '优质、高档的面料，大都具有穿著舒适、吸汗透气、悬垂挺括、视觉高贵、触觉柔美等几个方面的特点。面料主要测试项目涉及：PH值、摩擦色牢度、防火、沾水度、拉伸、耐洗度等的检验。',
              imgUrl: require('../assets/images/u1178.png'),
            },
            {
              id: 2,
              title: '纤维检测',
              content:
                '纤维主要包括植物纤维，动物纤维，矿物纤维等；化学纤维：人造纤维，合成纤维，无机纤维等；对纤维的检测项目主要是对成分分析、理化指标检测、阻燃性能、电学性能检测。',
              imgUrl: require('../assets/images/u1176.png'),
            },
            {
              id: 3,
              title: '纺织品检测',
              content:
                '纺织品项目主要包括纺织品成分检测、纺织品色牢度检测等相关检测项目，领域涵盖纺织面料、皮革毛皮、羽绒羽毛、箱包、鞋类、材料阻燃等。',
              imgUrl: require('../assets/images/u1179.png'),
            },
            {
              id: 4,
              title: '童装检测',
              content:
                '童装作为不具备或不完全具备自我保护能力的特殊人群，其生活用品的设计和生产均有特殊的要求。儿童服装在设计和生产过程中，除了考虑威胁人类安全的常规因素外，还要考虑其行为特点和心理特点。',
              imgUrl: require('../assets/images/u1177.png'),
            },
            {
              id: 5,
              title: '无纺布检测',
              content:
                '无纺布又称不织布，是由定向的或随机的纤维而构成，是新一代环保材料，具有防潮、透气、柔韧、质轻、不助燃、容易分解、无毒无刺激性、色彩丰富、价格低廉、可循环再用等特点。无纺布检测服务，项目涉及力学性能、化学性能、有害物质等',
              imgUrl: require('../assets/images/u1183.png'),
            },
          ],
        },
      ],
      adressServe: [
        {
          titleBar: [
            { id: 1, title: '原料供应商' },
            { id: 2, title: '生产商' },
            { id: 3, title: '经销商' },
            { id: 4, title: '用户' },
          ],
        },
      ],
      titleImg: {
        title: '关键指标',
        img: require('../assets/images/pro.png'),
      },

      ids: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    this.ids = this.$route.params.ids
  },
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="less">
</style>
